import React, { useCallback } from 'react';
import { Link } from 'gatsby';
import { IoIosArrowDropdownCircle } from 'react-icons/io';
import scrollTo from 'gatsby-plugin-smoothscroll';
import Button from '../../Button';
import useBannerSectionData from './dataQuery';
import { BannerContent, DefaultBackgroundImage } from './styles';
import { useModal } from '../../../hooks/modal';

interface BannerSectionProps {
  title: string;
  subtitle: string;
  buttonText: string;
}
const BannerSectionComponent: React.FC = () => {
  const { handleModal } = useModal();
  const data: BannerSectionProps = useBannerSectionData();

  const openModal = useCallback(() => {
    handleModal({ isOpen: true, action: 'signin' });
  }, []);

  return (
    <BannerContent>
      <div className="banner-section">
        <DefaultBackgroundImage />
        <div className="full-width-image">
          <div className="container">
            <h1 className="title">{data.title}</h1>
            <h2 className="subtitle">{data.subtitle}</h2>
            <Link to="/register">
              <Button title={data.buttonText} classType="fat" />
            </Link>
            <Button title="Entrar" classType="fat mobile-only outline" onClick={openModal} />
          </div>
        </div>
        <div className="bottom-button">
          <IoIosArrowDropdownCircle onClick={() => scrollTo('#info-section')} size={50} color="#ffffff" />
        </div>
      </div>
    </BannerContent>
  );
};

export default BannerSectionComponent;
